import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function oneSpecialCharacterValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const regex = /[\x21-\x2F]|[\x3A-\x40]|[\x5B-\x60]|[\x7B-\x7E]/;
    const isValid = regex.test(control.value);
    return isValid ? null : { oneSpecialCharacter: { value: control.value } };
  };
}
